var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0151 1.14346C16.9189 0.876753 16.7595 0.649864 16.5567 0.491013C16.3539 0.332162 16.1167 0.248358 15.8745 0.250024H2.12449C1.88256 0.250596 1.64597 0.335403 1.44342 0.494155C1.24086 0.652908 1.08105 0.878785 0.983372 1.14438C0.885691 1.40998 0.854338 1.70389 0.893116 1.99045C0.931894 2.27701 1.03914 2.54391 1.20183 2.75877L1.20808 2.76721L6.49949 9.54721V16.75C6.49944 17.0215 6.56078 17.2879 6.67699 17.5208C6.79319 17.7538 6.95989 17.9445 7.15933 18.0727C7.35876 18.2008 7.58343 18.2617 7.80941 18.2487C8.03538 18.2356 8.25417 18.1493 8.44246 17.9988L10.9425 15.9981C11.1138 15.8612 11.2544 15.6755 11.3515 15.4576C11.4487 15.2398 11.4995 14.9965 11.4995 14.7494V9.54721L16.7917 2.76721L16.7979 2.75877C16.9623 2.54489 17.0706 2.27764 17.1092 1.99037C17.1479 1.7031 17.1151 1.40854 17.0151 1.14346ZM10.5886 8.52627C10.3714 8.80245 10.2502 9.16753 10.2495 9.54721V14.7494L7.74949 16.75V9.54721C7.75022 9.16617 7.62947 8.79923 7.41199 8.52159L2.12449 1.75002H15.8745L10.5886 8.52627Z",
    fill: "url(#paint0_linear_5763_4158)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5763_4158",
    x1: 0.876953,
    y1: 18.2504,
    x2: 13.3776,
    y2: 14.4696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF375F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/Funnel.e1e555f206125c5ef3124a44fe11c1d0.svg";
export { ForwardRef as ReactComponent };